<template>
    <div
        class="c-side-toggle"
        @click.stop="toggleLeftSide"
        :class="{ mobileOnly: isMobileOnly, on: isOpen }"
    >
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 12 16" width="18" aria-hidden="true" v-bind:class="'u-toggle'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" d="M11.41 9H.59C0 9 0 8.59 0 8c0-.59 0-1 .59-1H11.4c.59 0 .59.41.59 1 0 .59 0 1-.59 1h.01zm0-4H.59C0 5 0 4.59 0 4c0-.59 0-1 .59-1H11.4c.59 0 .59.41.59 1 0 .59 0 1-.59 1h.01zM.59 11H11.4c.59 0 .59.41.59 1 0 .59 0 1-.59 1H.59C0 13 0 12.59 0 12c0-.59 0-1 .59-1z"/></svg>
    </div>
</template>

<script>
import Bus from "../service/bus";
export default {
    name: "LeftSideToggle",
    props: ["mobileOnly"],
    data: function() {
        return {
            isOpen: true,
        };
    },
    computed: {
        isMobileOnly: function() {
            return this.mobileOnly;
        },
    },
    methods: {
        toggleLeftSide: function() {
            let status = !this.isOpen;
            Bus.$emit("toggleLeftSide", status);
        },
    },
    mounted: function() {
        Bus.$on("toggleLeftSide", (data) => {
            this.isOpen = data;
        });

        if (window.innerWidth < 1024) {
            this.isOpen = false;
        }
    },
    components: {},
};
</script>

<style lang="less">
.c-side-toggle {
    .pointer;
    .size(20px, 28px);
    padding: 0 5px;
    .u-toggle {
        .h(29px);
        fill: @color;
    }
    &.mobileOnly {
        .none;
    }
    &.on {
        svg {
            fill: @primary;
        }
    }
}
@media screen and (max-width: @ipad) {
    .c-side-toggle {
        .db !important;
    }
}
</style>
